import React, { useCallback, useMemo } from 'react';
import { get } from 'lodash';
import withActiveCallAnimation from '../../../hoc/withActiveCallAnimation';
import withUpdateAlert from '../../../hoc/withUpdateAlert';
import withStartOutboundCall from '../../../hoc/withStartOutboundCall';
import withCallCenter from '../../../hoc/withCallCenter';
import ReturnCallButton from './ReturnCallButton';

function ReturnCallButtonContainer(props) {
  const {
    call,
    mutateUpdateAlert,
    onCallPhone,
    callCenterFeatureFlag,
    setOutboundToPhoneIdContext,
    isCallCenterActivatedContext,
    ...rest
  } = props;

  const onClick = useCallback(() => {
    if (callCenterFeatureFlag) {
      if (isCallCenterActivatedContext) {
        setOutboundToPhoneIdContext(get(call, 'from_phone.id'));
      }
    } else {
      onCallPhone(get(call, 'from_phone.id'));
      if (call && call.alert && !call.alert.completed_at) {
        mutateUpdateAlert({ completed: true, id: call.alert.id });
      }
    }
  }, [
    call,
    mutateUpdateAlert,
    onCallPhone,
    callCenterFeatureFlag,
    setOutboundToPhoneIdContext,
    isCallCenterActivatedContext,
  ]);

  const phoneNumber = useMemo(() => get(call, 'from_phone'), [call]);

  return <ReturnCallButton {...rest} onClick={onClick} phoneNumber={phoneNumber} />;
}

export default withCallCenter(
  withStartOutboundCall(withActiveCallAnimation(withUpdateAlert(ReturnCallButtonContainer))),
);
